/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type InterTreatmentFilledJournalEvent from "parog-web/models/inter-treatment-filled-journal-event";
import type Patient from "parog-web/models/patient";

interface Signature {
  Args: {
    patient: Patient;
  };
}

export default class extends Component<Signature> {
  get interTreatmentFilledJournalEvents(): InterTreatmentFilledJournalEvent[] {
    return this.args.patient.interTreatmentFilledJournalEvents || [];
  }
}
